export default "__VITE_ASSET__$cCpBwsJ__"